export enum ENTRY_STATUS {
  PENDING = 'pending',
  ACTIVE = 'active',
  REJECTED = 'rejected', // rejected by customer
  FRONTRUNNER = 'frontrunner',
  WINNER = 'winner',
  DECLINED = 'declined', // rejected by an admin after reviewing a pending entry
}
